import { attr, ProtoBaseModel, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import { FirstPartyAddon } from '@square/dashboard-protos/models/squareup/addons/shared/first_party_addons';
import { readOnly } from '@ember/object/computed';
import { SubscriptionRequirement, LocalizedAddon, LocalizedVertical } from '@square/dashboard-protos/models/squareup/addons/data/localized_addon';
import { SubscriptionStatus } from '@square/dashboard-protos/models/squareup/sub2/common';
import { computed } from '@ember/object';
import Enum from '@square/dashboard-utilities/utils/enum';
import { isPresent } from '@ember/utils';
import { DeviceProfileType } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/shared/device_profile_type';
import VerticalConfiguration from '@square/dashboard-data/models/device-profiles-v2/vertical-configuration';
import { camelize, underscore } from '@square/dashboard-utilities/utils/keys';
export const InstallationButtonStates = new Enum(['INSTALL', 'UNINSTALL', 'SUBSCRIBE', 'MANAGE_SUBSCRIPTION']);
const NO_SUBSCRIPTION = 'NO_SUBSCRIPTION';
const FREE_SUBSCRIPTION_AVAILABLE = 'FREE_SUBSCRIPTION_AVAILABLE';
const INSTALLED_ADDON_PAID_STATUS_PAID = 'PAID';

// Enum values come through as strings
export default ProtoBaseModel.extend({
  firstPartyAddon: attr(FirstPartyAddon),
  name: attr(String),
  shortFormDescription: attr(String),
  subscriptionRequirement: attr(SubscriptionRequirement),
  iconUrl: attr(String),
  isInstalled: readOnly('sellerSpecificDetails.installed'),
  isLoading: attr(Boolean, {
    defaultValue: false
  }),
  subscribedLocations: readOnly('sellerSpecificDetails.subscribed_locations'),
  subscriptionStatus: readOnly('sellerSpecificDetails.subscription_status'),
  sellerSpecificDetails: attr(LocalizedAddon.SellerSpecificDetails),
  saasAddonSpecificDetails: attr(LocalizedAddon.SaasAddonSpecificDetails),
  includedVerticals: repeated(LocalizedVertical),
  supportedVerticals: repeated(LocalizedVertical),
  installedAddonPaidStatus: readOnly('sellerSpecificDetails.installed_addon_paid_status'),
  canBeUninstalled: readOnly('sellerSpecificDetails.can_be_uninstalled'),
  manageSaasAddonFallbackUrl: readOnly('saasAddonSpecificDetails.manage_saas_addon_fallback_url'),
  isSubscriptionRequired: computed('subscriptionRequirement', function () {
    return SubscriptionRequirement[this.subscriptionRequirement] === SubscriptionRequirement.PAID_SUBSCRIPTION_REQUIRED;
  }),
  offersFreeTrial: computed('subscriptionRequirement', function () {
    return SubscriptionRequirement[this.subscriptionRequirement] === SubscriptionRequirement.PAID_SUBSCRIPTION_OFFERS_FREE_TRIAL;
  }),
  isFreeTrial: computed('subscriptionStatus', function () {
    return this.subscriptionStatus === SubscriptionStatus[SubscriptionStatus.FREE_TRIAL];
  }),
  isInstalledAndPaidAddon: computed('installedAddonPaidStatus', function () {
    return this.installedAddonPaidStatus === INSTALLED_ADDON_PAID_STATUS_PAID;
  }),
  installationButtonState: computed('isInstalled', 'canBeUninstalled', 'subscriptionRequirement', function () {
    if (this.isInstalled) {
      if (this.canBeUninstalled) {
        return InstallationButtonStates.UNINSTALL;
      } else {
        return InstallationButtonStates.MANAGE_SUBSCRIPTION;
      }
    } else if (this.subscriptionRequirement === NO_SUBSCRIPTION || this.subscriptionRequirement === FREE_SUBSCRIPTION_AVAILABLE) {
      return InstallationButtonStates.INSTALL;
    } else {
      return InstallationButtonStates.SUBSCRIBE;
    }
  }),
  includedForProfileTypes: computed('includedVerticals', function () {
    if (isPresent(this.includedVerticals)) {
      return this.includedVerticals.map(v => VerticalConfiguration.getProfileTypeForClientProductType(v.product_value)).map(profileTypeEnum => DeviceProfileType[profileTypeEnum]);
    }
    return [];
  }),
  supportedForProfileTypes: computed('supportedVerticals', function () {
    if (isPresent(this.supportedVerticals)) {
      return this.supportedVerticals.map(v => VerticalConfiguration.getProfileTypeForClientProductType(v.product_value)).map(profileTypeEnum => DeviceProfileType[profileTypeEnum]);
    }
    return [];
  })
}).reopenClass({
  fromProto(proto) {
    if (!proto) {
      return null;
    }
    return this.deserialize(underscore(proto.toJSON()));
  },
  toProto(obj) {
    return LocalizedAddon.fromObject(camelize(obj.toJSON()));
  }
});